import { render, staticRenderFns } from "./otherMeetingDetail.vue?vue&type=template&id=c47b95e6&scoped=true&"
import script from "./otherMeetingDetail.vue?vue&type=script&lang=js&"
export * from "./otherMeetingDetail.vue?vue&type=script&lang=js&"
import style0 from "./otherMeetingDetail.vue?vue&type=style&index=0&id=c47b95e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47b95e6",
  null
  
)

export default component.exports